import type { StateCreator } from 'zustand';
import clusterNominationSlice, { type ClusterNominationSliceState } from './clusterNominationSlice';
import mediaRequestSlice, { type MediaRequestSliceState } from './mediaRequestSlice';

type MediaSlices = ClusterNominationSliceState & MediaRequestSliceState;

const mediaSlices: StateCreator<MediaSlices> = (setState, getState, store) => ({
  ...clusterNominationSlice(setState, getState, store),
  ...mediaRequestSlice(setState, getState, store),
});

export type { MediaSlices };
export default mediaSlices;
